module.exports = __webpack_public_path__ + "img/micifr2.97469dec.png";